export const mainData = {
  address: [
    '107045, г. Москва, переулок Луков, 4/1',
    '644007, г. Омск, ул.Фрунзе, 80, оф. 715'
  ],
  email: 'viplaty@bk.ru',
  openingHours: 'Ежедневно с 9:00 до 21:00 по МСК',
  phone: '8 (800) 550-75-51',
  unformatedPhone: '88005507551',
};